<div class="credit-decisioning-reason-dialog">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <div class="mat-subtitle-1 header">Credit Approve</div>
      </div>
    </div>
    <!-- Row 1: Deal Status (full width) -->
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Deal Status</mat-label>
          <mat-select [formControl]="formControlDealStatus">
            @for (option of dealStatusOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!-- Row 2: Exception to Policy | Product -->
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Exception to Policy</mat-label>
          <mat-select [formControl]="formControlExceptionToPolicy">
            @for (option of yesNoOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Product</mat-label>
          <mat-select [formControl]="formControlProduct">
            @for (option of availableProductOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!-- Row 3: Bank Statements | Financials -->
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Bank Statements</mat-label>
          <mat-select [formControl]="formControlBankStatements">
            @for (option of yesNoOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (bankStatementsError) {
          <div class="hint-box hint-error"><span class="mdi mdi-alert-circle-outline"></span><span class="hint-text">{{bankStatementsError}}</span></div>
        }
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Financials</mat-label>
          <mat-select [formControl]="formControlFinancials">
            @for (option of yesNoOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (financialsError) {
          <div class="hint-box hint-error"><span class="mdi mdi-alert-circle-outline"></span><span class="hint-text">{{financialsError}}</span></div>
        }
      </div>
    </div>
    <!-- Row 4: Valuation Source | Credit Reference -->
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Valuation Source</mat-label>
          <mat-select [formControl]="formControlValuationSource">
            @for (option of valuationSourceOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Credit Reference</mat-label>
          <mat-select [formControl]="formControlCreditReference">
            @for (option of creditReferenceOptions; track option) {
              <mat-option  [value]="option">
                {{option}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <!-- Row 5: LVR | DSCR -->
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <currency-input title="LVR" [required]="!isBusinessLoanOrOverdraft()" [min]="0" [formControl]="formControlLvr" [prefix]="false" [disabled]="isBusinessLoanOrOverdraft()" [readonly]="isBusinessLoanOrOverdraft()" [placeholder]="isBusinessLoanOrOverdraft() ? '' : undefined">
        </currency-input>
        @if (lvrError) {
          <div class="hint-box hint-error"><span class="mdi mdi-alert-circle-outline"></span><span class="hint-text">{{lvrError}}</span></div>
        }
        @if (lvrWarning) {
          <div class="hint-box hint-warning"><span class="mdi mdi-alert-outline"></span><span class="hint-text">{{lvrWarning}}</span></div>
        }
      </div>
      <div class="col-lg-6 col-md-12">
        <currency-input title="DSCR" [required]="true" [min]="0" [formControl]="formControlDscr" [prefix]="false">
        </currency-input>
        @if (dscrError) {
          <div class="hint-box hint-error"><span class="mdi mdi-alert-circle-outline"></span><span class="hint-text">{{dscrError}}</span></div>
        }
        @if (dscrWarning) {
          <div class="hint-box hint-warning"><span class="mdi mdi-alert-outline"></span><span class="hint-text">{{dscrWarning}}</span></div>
        }
      </div>
    </div>
    <!-- Row 6: Approval Conditions (full width) -->
    <div class="row mb-4">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Approval Conditions</mat-label>
          <textarea matInput rows="5" wrap="hard" maxlength="7000" [formControl]="formControlApprovalConditions"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="width-100">
          <button color="primary" (click)="onSubmit(false)" mat-stroked-button>Cancel</button>
          <button color="primary" [disabled]="!canSubmit()" (click)="onSubmit(true)" mat-flat-button>Confirm</button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
